"use strict";

var _slicedToArray = require("/Users/ted/projects/ZiktoInsuranceWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var os = __importStar(require("os"));

var packageJson = require('../package.json'); // tslint:disable-line:no-require-imports no-var-requires

/**
 * Replaces occurrences of '/' with ':' in a string, since '/' is meaningful inside User-Agent strings as a separator.
 */


function replaceSlashes(s) {
  return s.replace('/', ':');
}

var baseUserAgent = "".concat(replaceSlashes(packageJson.name), "/").concat(packageJson.version, " ") + "node/".concat(process.version.replace('v', ''), " ") + "".concat(os.platform(), "/").concat(os.release());
var appMetadata = {};
/**
 * Appends the app metadata into the User-Agent value
 * @param appMetadata.name name of tool to be counted in instrumentation
 * @param appMetadata.version version of tool to be counted in instrumentation
 */

function addAppMetadata(_ref) {
  var name = _ref.name,
      version = _ref.version;
  appMetadata[replaceSlashes(name)] = version;
}

exports.addAppMetadata = addAppMetadata;
/**
 * Returns the current User-Agent value for instrumentation
 */

function getUserAgent() {
  var appIdentifier = Object.entries(appMetadata).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        name = _ref3[0],
        version = _ref3[1];

    return "".concat(name, "/").concat(version);
  }).join(' '); // only prepend the appIdentifier when its not empty

  return (appIdentifier.length > 0 ? "".concat(appIdentifier, " ") : '') + baseUserAgent;
}

exports.getUserAgent = getUserAgent;